<template>
    <div class="container-fluid" v-if="rastreador && posicao">

        <header-admin :rastreador="rastreador" :veiculo="veiculo"></header-admin>

        <vue-tabs >

            <v-tab title="INICIAL">
                <br/>
                <positions-maps :posicao="posicao"/>
            </v-tab>

            <v-tab title="CLIENTE" v-if="cliente">
                <div class="row">
                    <form-cliente :cliente="cliente"  :edit="false" :showFinanceiro="false"/>
                </div>
                <div class="row">
                    <table-telefones-clientes :height="null" :telefones="cliente.telefones" :edit="false"></table-telefones-clientes>
                </div>
            </v-tab>

            <v-tab title="OBS" v-if="veiculo">
                <br/>
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </v-tab>

            <v-tab title="DIREÇÃO NOTURNA" v-if="veiculo">
                <form-direcao-noturna :veiculo="veiculo"></form-direcao-noturna>
            </v-tab>

            <v-tab title="HISTÓRICO">
                <br/>
                <relatorio-periodo :id_rastreador="rastreador.id_rastreador"/>
            </v-tab>

            <v-tab title="ALERTAS" v-if="veiculo">
                <br/>
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </v-tab>

            <v-tab title="RELATÓRIOS" v-if="veiculo">
                <br/>
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </v-tab>

            <v-tab title="COMANDOS" v-if="rastreador">

                <br/>

                <div class="col-sm-3">
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </v-tab>

        </vue-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1><br/><br/><br/>
        </center>
    </div>
</template>
<script>
    import { Rastreador, Concox, Veiculo } from '../../class/index';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import HeaderAdmin from './HeaderAdmin';
    import Relatorios from '../../components/veiculo/Relatorios';
    import RelatorioPeriodo from '../relatorios/RelatorioPeriodo';
    import FormDirecaoNoturna from '../forms/FormDirecaoNoturna';
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import MapPosicao from "./partials/MapPosicao.vue";
    import PosicaoAtual from "./partials/PosicaoAtual.vue";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import FormCliente from '../forms/FormCliente';
    import TableTelefonesClientes from '../tables/TableTelefonesClientes';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import GoogleMapsButton from "../buttons/GoogleMapsButton.vue";
    import GoogleEarthButton from "../buttons/GoogleEarthButton.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';

    export default {
        name: 'Calamp',

        components: {
            PositionsMaps,
            GoogleEarthButton,
            GoogleMapsButton,
            TableTelefonesClientes,
            FormCliente,
            RelatorioAlertas,
            FormDirecaoNoturna, HeaderAdmin, Relatorios, RelatorioPeriodo,
            PosicaoAtual, MapPosicao, TableComandos, Reset,
            SolicitarConfiguracao
        },

        data(){
            return {
                config: null,
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            //this.config = await Concox.byPK(this.rastreador.id_rastreador);
        },
    }
</script>
